var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('div',{staticClass:"technical-doc"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._t("default",[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" View Technical Document ")])],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }